module.exports = require("./eu-ES");